module.exports = __webpack_public_path__ + "static/img/icon_talk.c1f532df.png";